import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input } from 'antd'

import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class WorkExperiencePage extends Component {
  static propTypes = {
    system: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
     const { workExperiencePage,currentWorkExperience} = this.props.system;
     this.fetchList( workExperiencePage);
  }

  fetchList = (page,values) => {
    const {getWorkExperienceList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getWorkExperienceList(params);
  }

  getDataSource() {
    const { system } = this.props;
    const { workExperienceById, workExperienceList } = system;
    if (!workExperienceList) return [];
    return workExperienceList.map(id => workExperienceById[id]);
  }

  get listProps() {
    const { system,actions } = this.props
    const { getWorkExperienceListPending,workExperienceTotal,workExperiencePage } = system
    const { deleteWorkExperience,chooseCurrentWorkExperience,workExperienceModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getWorkExperienceListPending,
      columns:[
        {
          title: "工作经验",
          dataIndex: 'timeRange',
          key: 'timeRange',
          width: 180,
        },
        {
          title: "排序号",
          dataIndex: 'orderNum',
          key: 'orderNum',
          width: 180,
        },
      ],
      pagination:{
        total:workExperienceTotal,
        current:workExperiencePage,
        onChange : (page) => {
          this.fetchList(page);
        }
      },
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentWorkExperience(record);
          workExperienceModalChange(true,"updata");
        }else if(item.key == 3){
            deleteWorkExperience(record.id).then((data) => {
            this.fetchList(workExperiencePage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { system,actions } = this.props
    const { currentWorkExperience, workExperienceModalVisible,workExperiencePage, workExperienceModalType,submitWorkExperiencePending } = system

    const { workExperienceModalChange,submitWorkExperience } = actions;
    const editItem  = workExperienceModalType === 'create' ? {} : currentWorkExperience
    return {
      item: workExperienceModalType === 'create' ? {} : currentWorkExperience,
      visible: workExperienceModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitWorkExperiencePending,
      title: `${
        workExperienceModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "timeRange",
          label: "工作经验",
          initialValue: editItem.timeRange,
          widget: Input,
          required: true
        },
        {
          key: "orderNum",
          label: "排序号",
          initialValue: editItem.orderNum,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitWorkExperience(Object.assign({},data,{})).then(data=> {
          workExperienceModalChange(false,"create");
          this.fetchList(workExperiencePage);
        })
      },
      onCancel() {
        workExperienceModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,system } = this.props
    const { currentWorkExperience,workExperiencePage} = system
    const { workExperienceModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "timeRange",
            widget: Input,
            widgetProps:{
                placeholder:"请输入工作经验"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        workExperienceModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,system } = this.props
    const { currentWorkExperience,workExperiencePage} = system
    const { workExperienceModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ workExperienceModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        {/* <CrudFilter {...this.filterProps} /> */}
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    system: state.system,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkExperiencePage);


// WEBPACK FOOTER //
// ./src/features/system/WorkExperiencePage.js